const checkSubVars = (
  sourceJson: GeoVarJson
): {
  [key: string]: SubVariable
} => {
  let subvars = sourceJson.SubVars
  return subvars
}
export default checkSubVars